var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('institute-select',{attrs:{"title":"Coverage","startMap":true,"hidePrice":!_vm.pays},on:{"select":function($event){_vm.$store.commit('setInitInstitute', $event);
          _vm.$router.push('/verification/new');}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }